//@ts-nocheck
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Box } from 'edenred-ui';

import * as transactionsHistoryActions from '@epi-actions/transactionsHistory';
import { Pagination } from '@epi-shared/components';
import { TransactionsHistoryTable } from '@epi-components/TransactionsHistoryTable/TransactionsHistoryTable';
import { getApplicationLanguageCode } from '@epi-store/application/application.selectors';
import { transactionsHistory } from '@epi-selectors/loading';

import './TransactionsHistory.scss';

interface TransactionsHistoryProps {
  isLoading: boolean;
  transactions: any[];
  totalPages: number;
  queryParameters: {
    sortingBy: string;
    descending: boolean;
    page: number;
  };
  languageCode: string;
  setTransactionsHistoryParameters: (params: any) => void;
}

function TransactionsHistory({
  isLoading,
  transactions,
  totalPages,
  queryParameters,
  languageCode,
  setTransactionsHistoryParameters
}: TransactionsHistoryProps) {
  useEffect(() => {
    setTransactionsHistoryParameters(queryParameters);
  }, [languageCode]);

  return (
    <div className="TransactionsHistory">
      <TransactionsHistoryTable
        isLoading={isLoading}
        transactions={transactions}
        sortBy={queryParameters.sortingBy}
        sortDirection={queryParameters.descending}
        onSortingChange={(sortingBy, descending) => {
          setTransactionsHistoryParameters({
            ...queryParameters,
            sortingBy,
            descending
          });
        }}
      />
      <Box pt={3}>
        <Pagination
          count={totalPages}
          page={queryParameters.page}
          onChangePage={page => {
            setTransactionsHistoryParameters({ ...queryParameters, page });
          }}
        />
      </Box>
    </div>
  );
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...transactionsHistoryActions
    },
    dispatch
  );

const mapStateToProps = state => ({
  totalPages: state.apiTransactionsHistory.totalPages,
  queryParameters: state.apiTransactionsHistory.queryParameters,
  transactions: state.apiTransactionsHistory.transactions,
  languageCode: getApplicationLanguageCode(state),
  isLoading: transactionsHistory(state)
});

const ConnectedTransactionsHistory = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionsHistory);

const ConnectedTransactionsHistoryWithRouter = withRouter(
  ConnectedTransactionsHistory
);
export { ConnectedTransactionsHistoryWithRouter as TransactionsHistory };
